var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-app flex-row align-items-center bo"},[_c('SignIn'),_c('CenterLoading'),_c('DialogMessage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }